/*
    This file contains all the URLS belong to location management menu
*/

// Menu keys
import { MENU_KEYS } from "@Vytelle/admin/src/constants/ApplicationMenuConstants";

const KEY = MENU_KEYS.COMPANY;

// Location params
export const COMPANY_PARAMS = {
  COMPANY_ID: ":companyId",
};

export const COMPANY_URLS = {
  /* TRIAL URLS   */
  COMPANY_LIST: KEY + "/list", // Company Listing
  COMPANY_DETAIL: KEY + `/detail/${COMPANY_PARAMS.COMPANY_ID}`, // Company Detail
  CREATE_COMPANY: KEY + "/create", // Create Company
  UPDATE_COMPANY: KEY + `/edit/${COMPANY_PARAMS.COMPANY_ID}`, // Update Company
};
